import {
  FEEDBACK_TYPE_BUGS,
  FEEDBACK_TYPE_FEATURE_REQ,
  FEEDBACK_TYPE_FEEDBACK,
} from "../../model";

export const defaultIsAutoAssign = {
  [FEEDBACK_TYPE_FEEDBACK]: false,
  [FEEDBACK_TYPE_BUGS]: false,
  [FEEDBACK_TYPE_FEATURE_REQ]: false,
};

export const defaultAutoAssignSources = {
  [FEEDBACK_TYPE_FEEDBACK]: [],
  [FEEDBACK_TYPE_BUGS]: [],
  [FEEDBACK_TYPE_FEATURE_REQ]: [],
};
